/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { HelpRequestType } from '@gh/builder-shared-data';
import { UserContext } from '@gh/common-shared';
import { isServerErrorStatus } from '@gh/core-data';
import { DialogService } from '@gh/core-ui';
import { tap$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';
import { helpBugRequestDialog } from '../components';
import { HelpBugRequestDialogConfig } from '../resources';

@Injectable()
export class HelpHttpErrorInterceptor implements HttpInterceptor {
  private helpDialogShown: boolean = false;

  constructor(private injector: Injector,
              private userContext: UserContext) {

  }

  get dialogService(): DialogService {
    return this.injector.get(DialogService);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap$({
        error: (response?: HttpErrorResponse) => {
          // show bug request dialog only if user context is initialized,
          // bug request dialog needs information from user context
          if (!req.url.includes('maintenance-status')) {
            if (response && isServerErrorStatus(response.status) && this.userContext.isInitialized()) {
              if (!this.helpDialogShown) {
                const dialogRef = this.dialogService.openWithInput(
                  helpBugRequestDialog,
                  <HelpBugRequestDialogConfig>{
                    mode: HelpRequestType.SystemBug,
                    stacktrace: response.error ? JSON.stringify(response.error) : void 0,
                  },
                );

                dialogRef.afterOpened()
                  .subscribe(() => {
                    this.helpDialogShown = true;
                  });

                dialogRef.afterClosed()
                  .subscribe(() => {
                    this.helpDialogShown = false;
                  });
              }
            }
          }
        },
      }));
  }
}
